// The Elevate part of the one dialer (CU-869fmbgfj): "Calling from R TCO 2
// (your desk) · change", or "Dial on your handset" + ask an admin when the
// desk isn't connected. Twilio practices see their caller-ID picker instead.
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Alert, Button, Link, Stack, Typography } from '@mui/material';
import { DESK_STATE, NO_HANDSETS_TEXT, deskStatus } from './dialerModel';

export default function ElevateDialSection({ desk, number, onChangeDesk, noDesks, isVoiceAdmin }) {
    const [copied, setCopied] = useState(false);
    const status = deskStatus(desk);
    const copy = async () => {
        try { await navigator.clipboard.writeText(number); setCopied(true); } catch { /* clipboard blocked */ }
    };
    const change = (
        <Link
            component="button"
            type="button"
            variant="caption"
            onClick={onChangeDesk}
            data-testid="dialer-change-desk"
            sx={{ fontWeight: 600, verticalAlign: 'baseline' }}
        >
            {status.state === DESK_STATE.PICK ? 'Pick desk' : 'change'}
        </Link>
    );
    // No handsets set up at all: "Pick desk" would open an empty list (CU-869fn2wd3).
    if (status.state === DESK_STATE.PICK && noDesks) {
        return (
            <Alert severity="info" data-testid="dialer-no-handsets" sx={{ py: 0.5 }}>
                {isVoiceAdmin ? NO_HANDSETS_TEXT.admin : NO_HANDSETS_TEXT.staff} You can dial on your handset meanwhile.
            </Alert>
        );
    }
    if (status.state === DESK_STATE.HANDSET) {
        return (
            <Alert severity="warning" data-testid="dialer-handset" sx={{ py: 0.5 }}>
                <Stack spacing={0.5}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{status.text}</Typography>
                    <Typography variant="caption">
                        Ask an admin to connect this desk in Settings → Phone system → Desks, so Call can ring it. · {change}
                    </Typography>
                    {number && (
                        <Button size="small" onClick={copy} sx={{ alignSelf: 'flex-start', px: 0 }}>
                            {copied ? 'Copied' : 'Copy number'}
                        </Button>
                    )}
                </Stack>
            </Alert>
        );
    }
    return (
        <Typography variant="caption" color="text.secondary" data-testid="dialer-desk">
            {status.text} · {change}
        </Typography>
    );
}

ElevateDialSection.propTypes = {
    desk: PropTypes.object,
    number: PropTypes.string,
    onChangeDesk: PropTypes.func.isRequired,
    // The practice has no handsets this user could pick (the desk list is loaded and empty).
    noDesks: PropTypes.bool,
    isVoiceAdmin: PropTypes.bool,
};
ElevateDialSection.defaultProps = { desk: null, number: '', noDesks: false, isVoiceAdmin: false };
